/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class UpdateSavedQueryInput {
  /**
  * The name of the saved query
  */
  'name': string;
  /**
  * A description of the saved query
  */
  'description'?: string | null;
  /**
  * The SQL query text
  */
  'query': string;
  /**
  * Tags for categorizing the saved query
  */
  'tags': Array<string>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "description",
      "baseName": "description",
      "type": "string",
      "format": ""
    },
    {
      "name": "query",
      "baseName": "query",
      "type": "string",
      "format": ""
    },
    {
      "name": "tags",
      "baseName": "tags",
      "type": "Array<string>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return UpdateSavedQueryInput.attributeTypeMap;
  }

  public constructor() {
  }
}

